module.exports = __webpack_public_path__ + "img/bj-sprite-grid-thumb.b52f9683.jpg";